import { all, fork, put, takeEvery } from "redux-saga/effects";
// import { useIntl } from 'react-intl';

import {

    // Queue Management
    QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE,
    // QUEUE_MANAGEMENT_LOAD_QUEUE_SUCCESS,
    QUEUE_MANAGEMENT_CREATE_QUEUE,
    QUEUE_MANAGEMENT_UPDATE_QUEUE,
    QUEUE_MANAGEMENT_DELETE_QUEUE,

    // QUEUE_MANAGEMENT_LOAD_POSITION,
    // // QUEUE_MANAGEMENT_LOAD_POSITION_SUCCESS,
    // QUEUE_MANAGEMENT_CREATE_POSITION,
    // QUEUE_MANAGEMENT_UPDATE_POSITION,
    // QUEUE_MANAGEMENT_DELETE_POSITION,

    // QUEUE_MANAGEMENT_LOAD_STAFF,
    // // QUEUE_MANAGEMENT_LOAD_STAFF_SUCCESS,
    // QUEUE_MANAGEMENT_CREATE_STAFF,
    // QUEUE_MANAGEMENT_UPDATE_STAFF,
    // QUEUE_MANAGEMENT_DELETE_STAFF,
    // END Queue Management

} from "../actions";

import {
    // Queue Management
    // settingGetQueueByDate,
    queueGetQueueByDate,
    queueAddQueue,
    queueUpdateQueue,
    queueDeleteQueue,

    // settingGetPosition,
    // settingAddPosition,
    // settingUpdatePosition,
    // settingDeletePosition,

    // settingGetStaff,
    // settingCreateStaff,
    // settingUpdateStaff,
    // settingDeleteStaff,
    // END Queue Management

} from "../../helpers/queue-api";

import {
    getQueueByDate,
    getQueueByDateSuccess,
    // getPosition,
    // getPositionSuccess,
    // getStaff,
    // getStaffSuccess,
} from "./actions";

import { NotificationManager } from '../../components/common/react-notifications';


const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}



// Queue Management
function* queueManagementLoadQueueByDate({ payload, token }) {
    // const intl = useIntl();
    try {

        const dateTimeNow = new Date
        const issuedDate = `${dateTimeNow.getFullYear()}/${(dateTimeNow.getMonth() + 1).toString().padStart(2, "0")}/${(dateTimeNow.getDate()).toString().padStart(2, "0")}`

        const dataRes = yield queueGetQueueByDate({
            issuedDate,
            ...payload,
        }, token);
        if (dataRes.status === 'success') {
            // let list = [];

            const list = dataRes.data.map((item, index) => {
                // const PullIntlManager = async (text) => {
                //     const intl = useIntl();
                //     return intl.formatMessage({ id: text })
                // }
                // const intl = useIntl();
                // let headName = ''
                // if (item.gender === "male") {
                //     headName = intl.formatMessage({ id: 'label.ms'})
                // } else if (item.gender === "female") {
                //     headName = intl.formatMessage({ id: 'label.ms'})
                // }

                return {
                    ...item,
                    no: index + 1,
                    label: `${item.first_name || (item.first_name_queue || "-")} ${item.last_name || (item.last_name_queue || "-")}`,
                    gender: item.gender || (item.gender_queue || ""),
                    value: item.id_queue,
                }
            });
            yield put(getQueueByDateSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* queueManagementAddQueue({ payload, token }) {
    try {
        const dataRes = yield queueAddQueue(payload, token);
        if (dataRes.status === 'success') {
            yield put(getQueueByDate({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* queueManagementUpdateQueue({ payload, token }) {
    try {
        const dataRes = yield queueUpdateQueue(payload, token);
        if (dataRes.status === 'success') {
            yield put(getQueueByDate({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getStaff({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* queueManagementDeleteQueue({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield queueDeleteQueue(items, token);
        if (dataRes.status === 'success') yield put(getQueueByDate({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* queueManagementLoadPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingGetPosition(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: item.name_position,
//                     value: item.id_position,
//                 }
//             ));
//             yield put(getPositionSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementAddPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingAddPosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementUpdatePosition({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdatePosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementDeletePosition({ payload, token }) {
//     const { items } = payload;
//     try {
//         const dataRes = yield settingDeletePosition(items, token);
//         if (dataRes.status === 'success') yield put(getPosition({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementLoadStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingGetStaff(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: `${item.first_name} ${item.last_name}`,
//                     value: item.id_staff,
//                 }
//             ));
//             yield put(getStaffSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementAddStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingCreateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementUpdateStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* queueManagementDeleteStaff({ payload, token }) {
//     // const { items } = payload;
//     try {
//         const dataRes = yield settingDeleteStaff(payload, token);
//         if (dataRes.status === 'success') yield put(getStaff({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// END Queue Management

// Queue Management
export function* watchLoadQueueByDate() {
    yield takeEvery(
        QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE,
        queueManagementLoadQueueByDate
    );
}
export function* watchAddQueue() {
    yield takeEvery(
        QUEUE_MANAGEMENT_CREATE_QUEUE,
        queueManagementAddQueue
    );
}
export function* watchUpdateQueue() {
    yield takeEvery(
        QUEUE_MANAGEMENT_UPDATE_QUEUE,
        queueManagementUpdateQueue
    );
}
export function* watchDeleteQueue() {
    yield takeEvery(
        QUEUE_MANAGEMENT_DELETE_QUEUE,
        queueManagementDeleteQueue
    );
}

// export function* watchLoadPosition() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_LOAD_POSITION,
//         queueManagementLoadPosition
//     );
// }
// export function* watchAddPosition() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_CREATE_POSITION,
//         queueManagementAddPosition
//     );
// }
// export function* watchUpdatePosition() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_UPDATE_POSITION,
//         queueManagementUpdatePosition
//     );
// }
// export function* watchDeletePosition() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_DELETE_POSITION,
//         queueManagementDeletePosition
//     );
// }

// export function* watchLoadStaff() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_LOAD_STAFF,
//         queueManagementLoadStaff
//     );
// }
// export function* watchAddStaff() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_CREATE_STAFF,
//         queueManagementAddStaff
//     );
// }
// export function* watchUpdateStaff() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_UPDATE_STAFF,
//         queueManagementUpdateStaff
//     );
// }
// export function* watchDeleteStaff() {
//     yield takeEvery(
//         QUEUE_MANAGEMENT_DELETE_STAFF,
//         queueManagementDeleteStaff
//     );
// }
// END Queue Management

export default function* rootSaga() {
    yield all([
        //  Queue Management
        fork(watchLoadQueueByDate),
        fork(watchAddQueue),
        fork(watchUpdateQueue),
        fork(watchDeleteQueue),

        // fork(watchLoadPosition),
        // fork(watchAddPosition),
        // fork(watchUpdatePosition),
        // fork(watchDeletePosition),

        // fork(watchLoadStaff),
        // fork(watchAddStaff),
        // fork(watchUpdateStaff),
        // fork(watchDeleteStaff),
    ])
}